module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_White-687843b535c71daac1477f3d2c01c525.png";